import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GaleriaKategoriaCard from "../components/cards/GaleriaKategoriaCard"
import tovabb from "../assets/media/icons/tovabb nyil.svg"
import { MDBContainer, MDBCol, MDBRow } from 'mdb-react-ui-kit';
import {useSelector} from "react-redux";
import { Helmet } from "react-helmet-async";


const GaleriaKategoriaPage = () => {

  const navigate = useNavigate();
  const [galleryList, setGalleryList] = useState([]);
  const { eventPlace } = useSelector(state => state);

  useEffect(() => {
    if (eventPlace?.galleries) {
        if (!Array.isArray(eventPlace.galleries)) {
            if (typeof eventPlace.galleries === 'object') {
                setGalleryList(Object.values(eventPlace?.galleries));
            } else {
                setGalleryList(eventPlace?.galleries);
            }
        } else {
          setGalleryList(eventPlace?.galleries);
        }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    
  }, [eventPlace, eventPlace?.galleries]);


  return (
    <>
    <Helmet>
        <title>Galéria - A Vértes Agorája</title>
    </Helmet>
    <section className="galeria-kategoria-section" id ="galeria-kategoria-section">
      <MDBContainer style={{maxWidth: "1008px", padding: 0}}>
            <div>
              <div className="navigate-div" style={{ marginTop: 0 }}>
                  <button onClick={() => {  navigate('/home')}}>Főoldal</button>
                  <img src={tovabb} alt="tovább nyíl"/>
                  <button >Galéria</button>
              </div>
              <div className="galeria-title">
                <h1>Galéria</h1>
              </div>
              <MDBRow className="galeria-row">
                  {galleryList.length > 0 ? galleryList.map((k, n) => {
                      return (
                          <MDBCol md="3" size="12" className="galeria-col" key={n}>
                              <GaleriaKategoriaCard msg={k}/>
                          </MDBCol>
                      )
                  }) : <span>Nincs megjeleníthető tartalom!</span>}

              </MDBRow>
            </div>
          
      </MDBContainer>
    </section>
    </>
  );
};

export default GaleriaKategoriaPage;
